import { DateTime } from "luxon";

export const getFormSubmissionName = (
  formName: string,
  dateRangeStartUtc: string | null,
  dateRangeEndUtc: string | null,
) => {
  const formSubmissionName: string[] = [formName];

  if (dateRangeStartUtc != null && dateRangeEndUtc != null) {
    const dateRangeStart = DateTime.fromISO(dateRangeStartUtc, { zone: "utc" }).toLocaleString(DateTime.DATE_MED);
    const dateRangeEnd = DateTime.fromISO(dateRangeEndUtc, { zone: "utc" }).toLocaleString(DateTime.DATE_MED);

    formSubmissionName.push(`${dateRangeStart} - ${dateRangeEnd}`);
  }

  return formSubmissionName.join(" | ");
};
